import { Grid, Box, Typography } from "@mui/material";
import { Image } from "@mui/icons-material";
import ReportCard from "./ReportCard";

export default function ReportList({ reports, search, onDeny, onAction }) {
  if (!reports.length) {
    return (
      <Box sx={{ textAlign: "center", py: 8 }}>
        <Image sx={{ fontSize: 60, opacity: 0.5, mb: 2 }} />
        <Typography variant="h6">
          {search ? "No matching reports found" : "No reports available"}
        </Typography>
      </Box>
    );
  }

  return (
    <Grid container spacing={3}>
      {reports.map((report) => (
        <Grid item xs={12} md={6} lg={4} key={report._id}>
          <ReportCard
            report={report}
            onDeny={onDeny}
            onAction={onAction}
          />
        </Grid>
      ))}
    </Grid>
  );
}
